import { TRESPONSE_GET_CAPACITY_STRIP_DETAILS } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';

export const CAPACITY_BOARD_STRIP_DETAILS_TABLE_MODEL = {
  createModel: (res: TRESPONSE_GET_CAPACITY_STRIP_DETAILS) => {
    return ModifiersZTableModel.createTableModel(
      res.detailedStripDTO,
      {
        padding: 8,
        headerConfig: res.headerInfo.map((h) => ({
          type: 'TEXT_CELL' as const,
          text: h.displayName,
          align: 'center' as const,
          widthInPx: 100,
        })),
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: res.headerInfo.map((h) => ({
            type: 'TEXT_CELL' as const,
            text: item[h.key] ?? '- -',
            align: 'center' as const,
          })),
        };
      },
    );
  },
};
